module.exports = __webpack_public_path__ + "static/media/chat.628cd99f.svg";